export interface IDivSafeZoneProps {
  id: string;
  className?: string;
  style?: React.CSSProperties;
}

export function DivSafeZone(props: IDivSafeZoneProps) {
  const { id, className, style } = props;

  return (
    <div
      id={id}
      className={className}
      // suppress hydration warnings because advertisements can alter the html before the app hydrates
      suppressHydrationWarning
      // dangerouslySetInnerHTML prevents hydration from clearing out advertisements
      dangerouslySetInnerHTML={{ __html: "" }}
      style={style}
    ></div>
  );
}

export default DivSafeZone;
